/**
 * Copyright (c) HashiCorp, Inc.
 */

import { HdsFormTextInputBase } from '@hashicorp/design-system-components/components';
import { or } from 'ember-truth-helpers';
import { on } from '@ember/modifier';

import type { TOC } from '@ember/component/template-only';
import type { HdsFormTextInputBaseSignature } from '@hashicorp/design-system-components/components/hds/form/text-input/base';

export interface FilterBarFilterFilterInputSignature {
  Args: {
    components: unknown;
    value: string;
    placeholder: string;
    onInput: (event: Event) => void;
    label: string;
    count: number;
    type: HdsFormTextInputBaseSignature['Args']['type'];
  };
  Blocks: {
    default: [];
  };
  Element: HTMLDivElement;
}

const FilterBarFilterFilterInput: TOC<FilterBarFilterFilterInputSignature> =
  <template>
    {{#let @components as |Components|}}
      {{! @glint-expect-error }}
      <Components.Header @hasDivider={{true}}>
        <HdsFormTextInputBase
          @type={{or @type "search"}}
          @value={{@value}}
          {{! template-lint-disable no-inline-styles }}
          style="margin: 8px 0;"
          placeholder={{or @placeholder "Search"}}
          aria-label={{or @placeholder "Search"}}
          {{on "input" @onInput}}
        />
        {{! @glint-expect-error }}
      </Components.Header>
      {{#if @label}}
        {{! @glint-expect-error }}
        <Components.Generic>
          <span
            class="hds-foreground-faint hds-typography-body-100 hds-font-weight-regular"
            {{! template-lint-disable no-inline-styles }}
            style="display: flex; justify-content: space-between; margin: 8px 0;"
          >
            <span>{{@label}}</span>
            {{#if @count}}
              <span>{{or @count 0}}</span>
            {{/if}}
          </span>
          {{! @glint-expect-error }}
        </Components.Generic>
      {{/if}}
    {{/let}}
  </template>;

export default FilterBarFilterFilterInput;
